module.exports = __webpack_public_path__ + "static/media/google-icon-in-btn.dcf387f7.svg";